import { useMutation, useQueryClient } from "@tanstack/react-query";
import { generatePath, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { ADMIN_USERS_ENDPOINTS, AdminUsersService } from "@/service/api/admin-users";
import { UpdateAdminUserDto } from "@/service/dto/admin-users";
import { getApiErrorMessage } from "@/modules/common/utils/apiError";
import { ROUTES } from "@/routes/constants/routes";

interface UpdateUserParams {
  id: string;
  data: UpdateAdminUserDto;
}

const useUpdateUser = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: UpdateUserParams) => AdminUsersService.updateUser(id, data),
    onError: (error) => {
      toast.error(getApiErrorMessage(error, "Erro ao atualizar usuário. Tente novamente mais tarde."), {
        toastId: "update_admin_user_error",
      });
    },
    onSuccess: (_data, { id }) => {
      toast.success("Usuário atualizado com sucesso!");
      navigate(generatePath(ROUTES.USERS.DETAILS, { id }));
      queryClient.invalidateQueries({ queryKey: [ADMIN_USERS_ENDPOINTS.GET_USERS] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_USERS_ENDPOINTS.GET_USER(id)], exact: true });
      queryClient.invalidateQueries({ queryKey: [ADMIN_USERS_ENDPOINTS.GET_TOTALIZERS] });
    },
  });
};

export default useUpdateUser;
